// i18n area 'storage' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.pl-PL.meta.json.
import type { enUS } from './storage'

export const plPL: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Utwórz storage',
      path: 'Ścieżka',
      pathHint: 'Ścieżka bezwzględna pod dozwolonym rootem (domyślnie /var/lib/tvirt/pools/)',
      shared: 'Storage współdzielony',
      sharedChip: 'współdzielony',
      sharedVerifiedChip: 'współdzielony · zweryfikowany',
      sharedVerifiedTooltip: 'Współdzielenie zweryfikowane: sondy krzyżowe potwierdzają, że każdy członek widzi dane zapisane przez pozostałych.',
      sharedDisputedChip: 'współdzielony · NIEzweryfikowany',
      sharedDisputedTooltip: 'Współdzielenie NIEzweryfikowane',
      sharedDisputedPair: '{observer} nie widzi danych zapisanych przez {writer}',
      sharedHint: 'Share sieciowy zamontowany lokalnie pod tą samą ścieżką na każdym członku — warunek konieczny live migration (deklaratywny).',
      sharedDanger: 'NIEBEZPIECZEŃSTWO — TVirt WIERZY tej fladze: po jej włączeniu każdy członek zakłada, że widzi TE SAME bajty pod tą ścieżką. Na folderze, który NIE jest naprawdę współdzielonym share (NFS/CIFS/klastrowy system plików), wynikiem jest uszkodzenie i utrata danych przy pierwszej migracji albo przy pierwszym restarcie HA na innym węźle. Włączać tylko wtedy, gdy ścieżka jest share zamontowanym identycznie na każdym węźle.',
      type: 'Typ',
      capacity: 'Pojemność',
      provisioned: 'Przydzielona',
      provisionedOvercommit: 'Potencjalne zobowiązanie ponad pojemność: woluminy thin mogą urosnąć do {n} GiB.',
      phase: { ready: 'Gotowy', degraded: 'Zdegradowany', error: 'Błąd' },

      // Runda #156 (dialog standardowy): PEŁNY dialog szczegółów — taby,
      // wiersze konfiguracji per sterownik i powierzchnia obserwowana.
      tabConfig: 'Konfiguracja',
      tabCapacity: 'Pojemność i stan',
      cardIdentity: 'Tożsamość',
      cardPlacement: 'Rozmieszczenie',
      cardConnection: 'Połączenie',
      usedReal: 'Rzeczywiste zajęcie',
      capacityUnknown: 'Węzeł nie zgłosił jeszcze pojemności tej puli — tutaj nie wymyśla się liczb',
      overcommitHint: 'Zobowiązanie ponad pojemność: legalne na pulach thin, warto pilnować rzeczywistego zajęcia',
      supportedContent: 'Obsługiwana zawartość',
      content: {
        disks: 'Dyski',
        catalogFiles: 'Pliki katalogu',
        backups: 'Kopie zapasowe',
        appVolumes: 'Woluminy aplikacji'
      },
      defaultDiskFormat: 'Domyślny format dysku',
      reserveGiB: 'Zarezerwowane wolne miejsce (GiB)',
      available: 'Dostępne',
      diskCount: 'Dyski',
      filesystem: 'System plików',
      observedAt: 'Zaobserwowano',
      lostAtRow: 'Zadeklarowano jako utracony',
      sharedProbeRow: 'Weryfikacja współdzielenia',
      sharedProbeNodes: 'Sondowane węzły',
      reachableFrom: 'Zadeklarowana osiągalność',
      reachableFromHint: 'Węzły, z których ten storage ma być osiągalny. VM, której dyski, obrazy ISO lub metadane tu żyją, nie uruchomi się ani nie zmigruje na węzeł spoza tej listy. Wszyscy członkowie są wstępnie zaznaczeni: zawężenie listy jest dowolne. Węzeł, który dołączy do klastra później, zostaje poza nią, dopóki nie zostanie tutaj dodany.',
      reachableFromNone: 'niezadeklarowana',
      reachableFromTags: 'Osiągalność według tagów',
      reachableFromTagsHint: 'Selektor tag=wartość (wpisy rozdzielone przecinkami, łączone przez AND): każdy członek noszący te tagi jest zadeklarowany jako osiągalny — dynamicznie: otagowanie węzła wciąga go do listy.',
      reachableFromTagsInvalid: 'Nieprawidłowy format — należy użyć tag=wartość, rozdzielonych przecinkami',
      reachableResolved: 'Rozwiązane węzły: {nodes}',
      reachableDeclaredNotSeen: 'zadeklarowany, ale niewidziany przez sondę współdzielenia na: {nodes}',
      reachableSeenNotDeclared: 'widziany, ale niezadeklarowany (poza perymetrem) na: {nodes}',
      cephCluster: 'Zarządzany klaster Ceph',
      appGuardTitle: 'Storage używany przez Aplikacje',
      appEphemeralGuard: 'ten storage jest efemeryczną pulą Aplikacji w klastrze — najpierw trzeba go zmienić na stronie Aplikacje, dopiero potem usunąć.',
      appInUseGuard: 'żyją tutaj roots i woluminy aplikacji: {apps} — najpierw trzeba je przenieść lub usunąć.',
      releaseRequiredTitle: "Usunąć '{name}' i zwolnić jego obrazy?",
      releaseRequiredBatchTitle: 'Usunąć wybrane storage i zwolnić ich obrazy?',
      releaseRequiredBody: 'Zwolnienie obrazów nie kasuje ŻADNEGO bajtu: wyrejestrowanie zostawia namespace na dysku, obrazy po prostu przestają być zmaterializowane, a każde odwołanie scope przeżywa jako claim — zarejestruj pool ponownie, a zostaną znowu przyjęte.',
      releaseConfirm: 'Usuń i zwolnij obrazy'
    },
    lost: {
      chip: 'Utracony',
      action: 'Zadeklaruj jako utracony',
      confirmTitle: 'Zadeklaruj storage jako utracony',
      confirmBody: 'Oświadczenie operatora na jego własne, zadeklarowane ryzyko: każdy task w kolejce lub w toku na tym storage albo na jego obiektach ZAKOŃCZY SIĘ BŁĘDEM, usunięcia stają się wyłącznie rejestrowe (żadnej pracy na systemie plików), a nowa praca fizyczna jest odrzucana. Bajty nigdy nie są ruszane — jeśli wolumin wróci do życia, wystarczy zarejestrować go ponownie i uruchomić skanowanie, aby wszystko na nowo adoptować.',
      confirmSubmit: 'Zadeklaruj jako utracony',
      error: 'Oświadczenie zostało odrzucone'
    },
    findings: {
      action: 'Znalezione obiekty',
      title: 'Znalezione obiekty',
      empty: 'Nie znaleziono żadnego obiektu w namespace storage',
      loadError: 'Nie można wczytać znalezionych obiektów',
      actionError: 'Decyzja została odrzucona',
      colKind: 'Typ',
      colObject: 'Obiekt',
      colConflict: 'Konflikt',
      namespaceNotice:
        'Ten katalog był już zainicjowany przez inny magazyn: pieczęć tożsamości została nadpisana pieczęcią tego magazynu. Zawartość NIE została ruszona — przejrzyj znalezione poniżej obiekty, zaimportuj te, których potrzebujesz, a potem odrzuć to powiadomienie.',
      kind: {
        disk: 'Dysk',
        catalogFile: 'Plik katalogu',
        vmMetadata: 'Metadane VM',
        namespace: 'Namespace',
        foreign: 'Obcy',
        volumeGroup: 'Grupa woluminów'
      },
      vgAdopt: {
        action: 'Adoptuj grupę woluminów',
        title: 'Adoptuj grupę woluminów',
        intro:
          'To urządzenie ma już grupę woluminów o nazwie TVirt, ale jej pieczęć nie wskazuje żadnego storage zarejestrowanego tutaj. Może to być to, co poprzedni storage TEGO klastra zostawił na LUN — albo to, co INNY klaster TVirt zostawił na LUN, który zmienił właściciela: stąd oba przypadki wyglądają identycznie i dlatego nikt nie decyduje za Ciebie.',
        irreversible: 'Spójrz na urządzenie, pieczęć i nazwę, zanim przejdziesz dalej: adopcji nie można cofnąć.',
        device: 'Urządzenie',
        seal: 'Pieczęć',
        sealNone: 'brak (brak tagu tvirt.storageId)',
        renameTo: 'Zostanie zmieniona nazwa na',
        renameNone: 'Bez zmiany nazwy: nazwa jest już tą, którą wyprowadza ten storage',
        volumesNote:
          'Zawarte woluminy NIE są adoptowane tym gestem: następny skan zaoferuje je pojedynczo, jako zwykłe znalezione obiekty.'
      },
      conflictChip: 'ID już istnieje',
      dismissedChip: 'Zignorowany',
      adopt: 'Adoptuj',
      adoptFileTitle: 'Importuj do katalogu',
      adoptFileHint: 'Pliki istnieją wyłącznie wewnątrz katalogów: należy wybrać katalog docelowy dla znalezionego pliku.',
      purge: 'Usuń z dysku',
      dismiss: 'Zignoruj',
      purgeConfirmTitle: 'Usuń z dysku',
      purgeConfirmBody: 'Znalezione bajty {id} zostaną usunięte ze storage. Operacja jest nieodwracalna.',
      taskStarted: 'Uruchomiono — dalej jako task w tle',
      scan: 'Skanuj storage',
      scanStarted: 'Skanowanie rozpoczęte…',
      scanDone: 'Skanowanie zakończone — znalezione obiekty są zaktualizowane'
    },
    reinit: {
      action: 'Ponów inicjalizację'
    },
    wizard: {
      addButton: 'Dodaj',
      title: 'Dodaj storage',
      back: 'Wstecz',
      continue: 'Dalej',
      selectHint: 'Wybór protokołu pokazuje, jak TVirt go używa.',
      roadmap: 'Roadmap',
      server: 'Serwer',
      export: 'Eksportowana ścieżka',
      share: 'Share',
      username: 'Nazwa użytkownika',
      password: 'Hasło',
      passwordHint: 'Tylko do zapisu: używane przy montowaniu, nigdy więcej niepokazywane.',
      credential: 'Poświadczenie',
      credentialManual: 'Wprowadź ręcznie',
      credentialHint: 'Wpis keystore typu nazwa użytkownika i hasło — alternatywa dla wpisywania ich tutaj.',
      credentialEmpty: 'Brak poświadczenia typu nazwa użytkownika i hasło w keystore — należy je utworzyć w sekcji System → Poświadczenia albo wpisać konto poniżej.',
      options: 'Opcje montowania',
      optionsHint: 'Rozdzielone przecinkami, przekazywane do mount -o dokładnie tak, jak są.',
      portal: 'Portal',
      portalHint: 'host[:port] — port domyślny to 3260.',
      target: 'Target IQN',
      targetHint: 'Nazwa targetu iSCSI, zaczyna się od iqn.',
      lun: 'LUN',
      wholeLunRow: 'Na dyskach: ten storage wskazuje tylko target',
      wholeLunHint: 'Ten storage wskazuje tylko target: jego LUN-y stają się dyskami jeden po drugim (Utwórz dysk → przejmij cały LUN), na targecie nic nie jest zapisywane.',
      lunHint: 'Numer LUN na targecie — w razie wątpliwości 0.',
      chapCredential: 'Poświadczenie (CHAP)',
      chapCredentialHint: 'Wpis keystore typu CHAP (iSCSI) używany przy logowaniu — sekret nigdy nie podróżuje razem ze storage.',
      chapNone: 'Brak uwierzytelniania',
      chapEmpty: 'Brak poświadczenia typu CHAP (iSCSI) w keystore — należy je utworzyć w sekcji System → Poświadczenia. Bez niego logowanie pozostaje nieuwierzytelnione.',
      address: 'Adres',
      addressHint: 'Host albo IP targetu NVMe/TCP (traddr).',
      port: 'Port',
      portHint: 'Port TCP targetu — 4420, jeśli pozostawiony pusty.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN subsystemu na targecie, zaczyna się od nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID wewnątrz subsystemu — w razie wątpliwości 1.',
      dhchapCredential: 'Poświadczenie (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Wpis keystore typu DH-HMAC-CHAP (NVMe) używany przy połączeniu — sekret nigdy nie podróżuje razem ze storage.',
      dhchapNone: 'Brak uwierzytelniania',
      dhchapEmpty: 'Brak poświadczenia typu DH-HMAC-CHAP (NVMe) w keystore — należy je utworzyć w sekcji System → Poświadczenia. Bez niego połączenie pozostaje nieuwierzytelnione.',
      monitors: 'Monitory',
      monitorsHint: 'Endpointy monitorów Ceph, host[:port], rozdzielone przecinkami lub nowymi wierszami — port domyślny 6789.',
      pool: 'Pula',
      poolHint: 'Pula RBD do wykorzystania — jeden obraz RBD na dysk.',
      fs: 'System plików',
      fsHint: 'Nazwa systemu plików CephFS (mds_namespace przy montowaniu).',
      fsPath: 'Ścieżka wewnątrz systemu plików',
      fsPathHint: 'Ścieżka bezwzględna wewnątrz systemu plików, którą storage montuje — w razie wątpliwości /.',
      cephxCredential: 'Poświadczenie (cephx)',
      cephxCredentialHint: 'Wpis keystore typu cephx: nazwa użytkownika = nazwa klienta (client.…), sekret = klucz base64. Obowiązkowy.',
      cephxNone: 'Brak poświadczenia cephx w keystore — należy utworzyć jedno (typ: cephx) w sekcji System → Poświadczenia albo pozwolić, by zarządzany klaster Ceph wykuł je akcją "Zaproponuj jako storage".',
      sharedByNature: 'Storage sieciowe są współdzielone z natury: każdy członek montuje je pod tą samą ścieżką zarządzaną przez TVirt.',
      error: 'Storage został odrzucony',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Inne',
        legacy: 'Legacy'
      },
      legacyHint: 'Wspierane pod każdym względem — po prostu nie wybieralibyśmy ich do nowej instalacji.',
      proto: {
        // Wiersz `usage` (Luca 2026-07-24) mówi, jak TVirt używa protokołu —
        // przede wszystkim jakie treści są dozwolone: dir/nfs/cifs mieszczą
        // dyski ORAZ obrazy ISO/dysków i template, sterowniki blokowe
        // (iscsi/nvme-tcp/rbd) TYLKO dyski.
        dir: {
          name: 'Folder lokalny',
          desc: 'Folder na węźle: prosty i szybki. Jest LOKALNY dla jednego węzła, chyba że ścieżka jest naprawdę współdzielonym share — oznaczenie go jako współdzielonego, gdy taki nie jest, kosztuje dane.',
          usage: 'TVirt trzyma tutaj dyski VM, obrazy ISO/dysków i template.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Eksport NFS montowany przez klaster — współdzielony z natury.',
          usage: 'Mieści dyski VM, obrazy ISO/dysków i template.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Share Windows/Samba montowany przez klaster — współdzielony z natury.',
          usage: 'Mieści dyski VM, obrazy ISO/dysków i template.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Zdalny system plików przez SSH — bez potrzeby eksportu NAS.',
          usage: 'W roadmapie.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blokowe LUN-y po IP ze współdzielonym LVM na wierzchu.',
          usage: 'Tylko dyski — jeden wolumin thin na dysk; nie mieści obrazów ISO ani template.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Urządzenia blokowe rozproszone na klastrze Ceph.',
          usage: 'Tylko dyski — jeden obraz RBD na dysk, otwierany natywnie przez QEMU; nie mieści obrazów ISO.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Rozproszony system plików Ceph, montowany przez kernel na klastrze — shared by nature.',
          usage: 'Mieści dyski VM, obrazy ISO/dysków i template — rodzina dir na systemie plików Ceph (poświadczenie cephx obowiązkowe).'
        },
        fc: { name: 'SCSI/FC', desc: 'LUN-y SCSI na fabric FibreChannel — klasyczny SAN FC.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'To samo SCSI po FibreChannel, z ramkami FC enkapsulowanymi w Ethernecie.' },

        // Żywy od rundy #132 — kluczem jest nazwa sterownika z contractu,
        // dzięki czemu chip na liście storage rozwiązuje ten sam wpis.
        'iscsi-lun': {
          name: 'iSCSI (całe LUN-y)',
          desc: 'Target iSCSI jako nośnik całych LUN-ów: każdy dysk JEST LUN-em, przekazanym surowo do gościa — bez LVM pośrodku.',
          usage: 'Tylko dyski — jeden cały LUN na dysk, przejęty bez zmian; dom SAN dysków ze współdzielonym zapisem.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (całe namespace)',
          desc: 'Podsystem NVMe jako nośnik całych namespace: każdy dysk JEST namespace, przekazanym surowo do gościa.',
          usage: 'Tylko dyski — jeden cały namespace na dysk, przejęty bez zmian; współdzielony zapis tak, SCSI persistent reservations nie.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Zdalne NVMe — bez SCSI na ścieżce — po zwykłym TCP, ze współdzielonym LVM na wierzchu.',
          usage: 'Tylko dyski — jeden wolumin thin na dysk; nie mieści obrazów ISO ani template.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Zdalne NVMe na fabric FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe na fabric FibreChannel, który FCoE przenosi wewnątrz Ethernetu — warstwy FCoE i NVMe/FC ułożone jedna na drugiej.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI ze ścieżką danych przeniesioną na RDMA — dowolny fabric (InfiniBand, iWARP, RoCE). Wyparte przez NVMe/RDMA, wciąż obecne w macierzach i w ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Natywne SCSI po RDMA, era przed iSER: InfiniBand (z discovery na poziomie fabric) i RoCE — przetrwało w leciwych storage HPC.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Zdalne NVMe na dowolnym fabric RDMA — InfiniBand, iWARP, RoCE v1 i v2: jedna konfiguracja, to węzeł mówi, który ma.' },
        s3: { name: 'S3', desc: 'Object storage zgodny z S3 — obrazy i backupy.' }
      }
    },
    catalogs: {
      title: 'Katalogi',
      createTitle: 'Utwórz katalog',
      editTitle: 'Edytuj katalog',
      docTitle: 'Katalog',
      notFound: 'Ten katalog (już?) nie istnieje',
      scopeHint: 'Kto czyta ten scope, widzi (i może używać) każdy plik katalogu',
      files: 'Pliki',
      noFiles: 'Brak plików',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // Katalog systemowy (runda #126): dom wbudowanych obiektów
      // platformy — czytelny dla wszystkich, zapisywalny dla nikogo.
      systemChip: 'systemowy',
      systemTooltip: 'Katalog systemowy: mieści wbudowane obiekty platformy i nie da się go modyfikować'
    },

    // Pliki katalogu (runda K1, inventory v2e/v2g): katalog jest domem
    // artefaktów plikowych klastra — jedna lista, tytuły per kind.
    catalogFiles: {
      catalog: 'Katalog',
      kindLabel: 'Typ',
      physicalSize: 'Rozmiar fizyczny',
      virtualSize: 'Rozmiar wirtualny',

      // Runda K3 (#64) + K4 (#65, ova/ovf z mapowaniem boot-survival):
      // materializuje plik vm-template jako VM Template w inwentarzu.
      importTemplateAction: 'Importuj jako VM Template',
      importTemplateLegacy: 'Brak zadeklarowanego formatu — użyteczny jako seed dla dysków, nieimportowalny',
      importTemplateTitle: 'Importuj jako VM Template',
      importTemplateSubmit: 'Importuj',
      importTemplateError: 'Import się nie powiódł',
      importTemplateHint: 'Pakiet .tvtpl staje się VM Template: zamrożony sprzęt z manifestu plus jeden dysk na wpis archiwum, każdy zweryfikowany względem własnej sumy kontrolnej. Karty NIC i napędy CD/DVD nie są częścią archiwum — dodaje się je po imporcie.',
      importTemplateQcow2Hint: 'Goły qcow2 staje się template z JEDNYM dyskiem i zadeklarowanym sprzętem domyślnym: profil linux, UEFI, 2 vCPU, 2048 MiB, rozruch z jedynego dysku. Do poprawienia przy wdrożeniu.',
      importTemplateName: 'Nazwa template',
      importTemplateNameHint: 'Puste = {name} (-import-<n>, jeśli zajęte)',
      importTemplateStorage: 'Storage na dyski',
      importTemplateMetadataStorage: 'Storage metadanych',
      importTemplateMetadataHint: 'Storage blokowy nie mieści metadanych VM (firmware, varstore) — należy wybrać dir/nfs/cifs.',
      importTemplateStarted: 'Import rozpoczęty — template pojawi się w karcie Template po zamknięciu taska.',

      // Mówiące etykiety w liczbie pojedynczej (#86): findings i spis mówią,
      // CZYM jest plik — ogólne 'Plik katalogu' zostaje tylko jako fallback.
      kind: {
        iso: 'Obraz ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Template VM',
        'oci-image': 'Obraz OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      title: {
        iso: 'Obrazy ISO',
        'ct-rootfs': 'Template CT',
        'vm-template': 'Template VM',
        'oci-image': 'Obrazy OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      createTitle: {
        iso: 'Dodaj obraz ISO',
        'ct-rootfs': 'Zarejestruj template CT',
        'vm-template': 'Dodaj template VM',
        'oci-image': 'Dodaj obraz OCI',
        'firmware-ovmf': 'Dodaj firmware OVMF'
      },
      formatHint: 'Wyprowadzony z rozszerzenia wybranego pliku — do poprawienia, jeśli zgadł źle',
      tarballHint: 'Tarball rootfs w standardowym formacie LXC (.tar.gz / .tar.xz / .tar.zst / .tar.bz2 albo zwykły .tar)',
      ociArchiveHint: 'Tarball docker-archive / oci-archive (.tar lub .tar.gz), na przykład z docker save',
      uploadResumeHint: 'Upload przerwany — plik czeka na wysłanie: ponowne wysłanie tego samego pliku wznowi upload',
      moveTitle: 'Przenieś plik',
      moveHint: 'Dwa niezależne wymiary: Katalog przenosi powiązanie (to samo id, żaden bajt się nie rusza, scope staje się scope katalogu docelowego); Storage przenosi dane — każda powiązana kopia podąża za nimi, odrzucane, dopóki plik jest w użyciu. Wybrane razem: najpierw katalog, potem storage.',
      moveCatalog: 'Katalog docelowy',
      moveCatalogHint: 'Dom zmienia tylko powiązanie: VM, która ma plik zamontowany, musi widzieć katalog docelowy',
      keepCurrent: 'Nie zmieniaj',
      rehomed: 'Powiązanie przeniesione do wybranego katalogu',
      copyAction: 'Kopiuj do katalogu…',
      copyTitle: 'Kopiuj do katalogu',
      copyLinkHint: 'Kopia to nowe powiązanie z tymi samymi danymi — nic nie jest duplikowane na storage.',
      copyCatalog: 'Katalog docelowy',
      copyCatalogHint: 'Kopiowanie to sposób, w jaki plik wędruje między katalogami',
      sameCatalog: 'Ten sam co źródłowy',
      sharedObjectHint: 'Dane tego pliku są współdzielone przez powiązane kopie w liczbie {count}',
      deleteLastLink: 'To OSTATNIE powiązanie z tą zawartością: usunięte zostaną także dane ze storage.',
      deleteLinkOnly: 'Usunięte zostanie tylko to powiązanie — dane zostają, wciąż osiągalne z pozostałych powiązanych kopii ({count}).',
      noCatalog: 'Nie ma żadnego katalogu — należy jakiś utworzyć',
      inlineCatalogName: 'Nazwa katalogu',

      // Pliki wbudowane w platformę (runda #126): storage null — czyta się je
      // i klonuje, nigdy move/delete/rename.
      embeddedChip: 'wbudowany',
      embeddedStorage: 'Wbudowany w platformę',
      embeddedNoMove: 'Plik wbudowany w platformę: nie żyje na żadnym storage — zamiast tego należy go sklonować',
      embeddedCopyHint: 'Klon materializuje wbudowane bajty na prawdziwym storage: wystarczy wybrać storage i katalog docelowy — kopia jest zwykłym plikiem',
      sourceEmbedded: 'Wbudowany w platformę',
      nodesRow: 'Obecność na węzłach',
      nodesSummary: '{present} z {total} węzłów ją ma',
      nodePresent: 'obecny',
      nodeMissing: 'brak',
      nodeUnknown: 'jeszcze nie zgłoszono',
      nodesHint: 'Zasób znajduje się na dysku każdego węzła (pakiet trantor-tvirt-assets): węzeł, który go nie ma, nie może ani zdefiniować VM z tym firmware, ani udostępnić Guest Tools. Różne wersje na węzłach są normalne podczas aktualizacji kroczącej.',

      // Pobieranie (runda #108): bajty podróżują ze swoim własnym uprawnieniem.
      downloadAction: 'Pobierz',
      downloadNotReady: 'Zawartość nie jest jeszcze gotowa — pobieranie wymaga pliku w stanie ready',
      downloadDenied: 'Rola użytkownika nie obejmuje catalog.download — pobranie bajtów to prawo oddzielne od użycia pliku',

      // Runda #156 (dialog standardowy): brakujące wiersze odczytu w dialogu
      // szczegółów — fakty o współdzielonym obiekcie, zadeklarowana suma
      // kontrolna, użytkownicy.
      objectRow: 'Obiekt storage',
      objectLinksRow: 'Powiązane kopie',
      declaredChecksum: 'Zadeklarowany SHA-256',
      usedByRow: 'Używany przez',
      usedByVms: 'VM',
      usedByDisks: 'Dyski',
      transferRow: 'Transfer',
      storageLockHint: 'Zmienia się tylko akcją Przenieś'
    },

    // Spis per storage (runda K1, inventory v2b #2): tylko do odczytu,
    // każdym obiektem zarządza się z jego własnej sekcji.
    objects: {
      action: 'Przeglądaj zawartość',
      title: 'Zawartość storage',
      hint: 'Spis w trybie tylko do odczytu tego, co żyje na tym storage — każdym obiektem zarządza się z jego własnej sekcji.',
      empty: 'Brak obiektów zarejestrowanych na tym storage',
      loadError: 'Nie można wczytać zawartości',
      colDetail: 'Szczegół',
      manage: 'Zarządzaj w jego sekcji',
      kind: {
        disk: 'Dysk',
        catalogFile: 'Plik katalogu',
        ociBlob: 'Blob OCI',
        checkpoint: 'Checkpoint',
        vmMetadata: 'Metadane VM',
        appRoot: 'Root aplikacji',
        appVolume: 'Wolumin aplikacji'
      }
    },
    inventory: {
      tabCatalogs: 'Katalogi',
      storage: 'Storage',
      sizeGib: 'Rozmiar (GiB)',
      format: 'Format',
      size: 'Rozmiar',
      sourceType: 'Źródło',
      sourceFile: 'Wysłanie pliku',
      sourceUrl: 'Pobranie z URL',
      file: 'Plik',
      url: 'URL',
      checksum: 'Suma kontrolna SHA-256',
      checksumHint: 'Obowiązkowa: pobranie jest weryfikowane względem tego SHA-256',
      verifyChecksum: 'Weryfikuj sumę kontrolną',
      checksumOffHint: 'Pobranie zostanie przyjęte bez weryfikacji — obliczony SHA-256 i tak jest zapisywany',
      uploading: 'Wysyłanie…',
      move: {
        action: 'Przenieś',
        diskTitle: 'Przenieś dysk',
        target: 'Storage docelowy',
        diskHint: 'Dysk zachowuje swoją tożsamość: bajty wędrują na wybrany storage. VM, która go używa, musi być wyłączona; przy istniejących snapshotach strona iSCSI odrzuca przeniesienie.',
        noTargets: 'Brak zgodnego storage docelowego',
        submit: 'Przenieś',
        error: 'Przeniesienie zostało odrzucone'
      },
      clone: {
        action: 'Klonuj',
        title: 'Klonuj dysk',
        name: 'Nazwa kopii',
        storage: 'Storage docelowy',
        sameStorage: 'Ten sam co źródłowy',
        linked: 'Linked clone',
        linkedHint: 'Natychmiastowy overlay qcow2 przykuty do dysku źródłowego (tylko źródła qcow2). Domyślnie wykonywana jest pełna kopia.',
        linkedCrossHint: 'Linked clone zostaje na storage źródła: aby go włączyć, trzeba wybrać "Ten sam co źródłowy".',
        submit: 'Klonuj',
        error: 'Klonowanie zostało odrzucone'
      },
      copy: {
        action: 'Kopiuj',
        name: 'Nazwa kopii',
        storage: 'Storage docelowy',
        sameStorage: 'Ten sam co źródłowy',
        submit: 'Kopiuj',
        error: 'Kopiowanie zostało odrzucone'
      },
      taskStarted: 'Uruchomiono — dalej jako task w tle',
      cephObjects: 'Przejdź do szczegółów obiektu w Ceph',
      phase: {
        ready: 'Gotowa',
        creating: 'Tworzenie',
        'awaiting-upload': 'Oczekuje na upload',
        downloading: 'Pobieranie',
        verifying: 'Weryfikacja',
        deleting: 'Usuwanie',
        error: 'Błąd',
        'in-use': 'W użyciu'
      }
    }
  }
}
